import styled from "@emotion/styled";
import { DeviceType, useDeviceType } from "hooks/useDeviceType";

export const NavbarContainer = styled.div(props => {
  const isTablet = useDeviceType() === DeviceType.Tablet;

  return {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    background: "black",
    height: "100%",
    minHeight: "206px",
    padding: isTablet ? "12px 12px 25px 12px" : "32px 24px",
    top: "0",
    width: isTablet ? "80px" : "206px",
    borderRadius: "14px",
    fontWeight: props.theme.fontWeights["work-sans-0"],
    boxShadow: props.theme["Card Shadow"],
    fontFamily: props.theme.fontFamilies.Primary,
  };
});
